import { FieldTypesE } from './fields';

export type SourcesFormT = {
  [key: string]: Array<SourcesFormFieldT>;
}

export type SourcesFormFieldT = {
  name: string;
  displayName: string;
  type: FieldTypesE;
  disabled?: boolean;
  comment?: string;
}

type SourcesIdentifiersT = {
  displayName: string;
  parametersGroupName: string;
}

// Backend: acklio-ipcore-api/ipcorecdp/source.proto
export const SourcesIdentifiers: Record<string, SourcesIdentifiersT> = {
  ACKLIO_LNS_SOURCE: { displayName: 'Acklio LNS', parametersGroupName: 'acklioLns' },
  IOT_CREATOR_SOURCE: { displayName: 'IoT Creator', parametersGroupName: 'iotCreator' },
  OBJENIOUS_SPOT_SOURCE: { displayName: 'Objenious', parametersGroupName: 'objenious' },
  NW_SIGFOX_SOURCE: { displayName: 'Sigfox', parametersGroupName: 'sigfox' },
  NBIOT_SCEF_SOURCE: { displayName: 'NBIOT SCEF', parametersGroupName: 'nbIot' },
  MOCK_LNS_SOURCE: { displayName: 'Mock LNS', parametersGroupName: 'mock' },
  ACKLIO_LNS_WS_SOURCE: { displayName: 'Acklio LNS Websocket', parametersGroupName: 'acklioLnsWs' },
  ACTILITY_THINGPARK_SOURCE: { displayName: 'Actility Thingpark', parametersGroupName: 'actility' },
  SENRA_SOURCE: { displayName: 'Senra', parametersGroupName: 'senra' },
  TCL_SOURCE: { displayName: 'TCL', parametersGroupName: 'tcl' },
  ACKLIO_LNS_DIRECT_SOURCE: { displayName: 'Acklio LNS Direct', parametersGroupName: 'acklioLnsDirect' },
  CHIRPSTACK_UNICAST_SOURCE: { displayName: 'Chirpstack Unicast', parametersGroupName: 'chirpstackUnicast' },
  CHIRPSTACK_MULTICAST_SOURCE: { displayName: 'Chirpstack Multicast', parametersGroupName: 'chirpstackMulticast' },
  INNOVID_SOURCE: { displayName: 'Innovid', parametersGroupName: 'innovid' },
  ANTARES_SOURCE: { displayName: 'Antares', parametersGroupName: 'antares' },
  EVERYNET_SOURCE: { displayName: 'Everynet', parametersGroupName: 'everynet' },
  TTS_SOURCE: { displayName: 'The Things Stack', parametersGroupName: 'tts' },
  ORANGE_LIVEOBJECTS_SOURCE: { displayName: 'Orange Live Objects', parametersGroupName: 'orangeLiveObjects' },
  KERLINK_SPN_SOURCE: { displayName: 'Kerlink SPN', parametersGroupName: 'kerlinkSpn' },
  KERLINK_WANESY_SOURCE: { displayName: 'Kerlink Wanesy', parametersGroupName: 'kerlinkWanesy' },
  AWS_IOT_CORE_SOURCE: { displayName: 'AWS IoT Core', parametersGroupName: 'awsIotCore' },
  IP_DTLS_SOURCE: { displayName: 'IP DTLS', parametersGroupName: 'ipDtls' },
  ACTILITY_THINGPARK_WS_SOURCE: { displayName: 'Actility Websocket', parametersGroupName: 'actilityWs' },
};

export const SourcesCommonFields: Array<SourcesFormFieldT> = [
  {
    name: 'mtuTxLink', displayName: 'Default MTU for downlink', type: FieldTypesE.NUMBER,
  },
  {
    name: 'useDefaultMtu', displayName: 'Disable dynamic MTU', type: FieldTypesE.CHECKBOX, comment: 'Always uses the downlink MTU configured in the source',
  },
];

// Backend: acklio-ipcore-api/ipcorecdp/source_parameters.proto
export const SourcesForm: SourcesFormT = {
  ACKLIO_LNS_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'username', displayName: 'Username', type: FieldTypesE.TEXT,
    },
    {
      name: 'password', displayName: 'Password', type: FieldTypesE.TEXT,
    },
    {
      name: 'headers.X-ACKLIO-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
    {
      name: 'ca', displayName: 'CA Certificate', type: FieldTypesE.TEXT_MULTILINES,
    },
    {
      name: 'crt', displayName: 'Client Certificate', type: FieldTypesE.TEXT_MULTILINES,
    },
    {
      name: 'privateKey', displayName: 'Private Key', type: FieldTypesE.TEXT_MULTILINES,
    },
    {
      name: 'downlinkAddress', displayName: 'LPWAN server address', type: FieldTypesE.TEXT,
    },
  ],
  ORANGE_LIVEOBJECTS_SOURCE: [
    {
      name: 'apiKey', displayName: 'API Key', type: FieldTypesE.TEXT,
    },
    {
      name: 'username', displayName: 'Username', type: FieldTypesE.TEXT,
    },
    {
      name: 'password', displayName: 'Password', type: FieldTypesE.TEXT,
    },
    {
      name: 'keepAlive', displayName: 'Keep Alive', type: FieldTypesE.TEXT,
    },
    {
      name: 'topic', displayName: 'Topic', type: FieldTypesE.TEXT,
    },
    {
      name: 'clientID', displayName: 'Client ID', type: FieldTypesE.TEXT,
    },
  ],
  NW_SIGFOX_SOURCE: [
    {
      name: 'headers.X-SIGFOX-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'body', displayName: 'Response URI', type: FieldTypesE.TEXT_MULTILINES,
    },
    {
      name: 'clientID', displayName: 'Client ID', type: FieldTypesE.TEXT,
    },
  ],
  NBIOT_SCEF_SOURCE: [],
  MOCK_LNS_SOURCE: [],
  ACKLIO_LNS_WS_SOURCE: [
    {
      name: 'apiKey', displayName: 'API Key', type: FieldTypesE.TEXT,
    },
    {
      name: 'url', displayName: 'Websocket URI', type: FieldTypesE.TEXT,
    },
  ],
  ACTILITY_THINGPARK_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'headers.X-ACTILITY-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
    {
      name: 'downlinkAddress', displayName: 'LPWAN server address', type: FieldTypesE.TEXT,
    },
    {
      name: 'appServerID', displayName: 'Connection Identifier', type: FieldTypesE.TEXT,
    },
    {
      name: 'apiKey', displayName: 'Tunnel Interface Authentication Key', type: FieldTypesE.TEXT,
    },
  ],
  OBJENIOUS_SPOT_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'apiKey', displayName: 'API Key', type: FieldTypesE.TEXT,
    },
    {
      name: 'headers.X-OBJENIOUS-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
  ],
  SENRA_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'apiKey', displayName: 'API Key', type: FieldTypesE.TEXT,
    },
    {
      name: 'headers.X-SENRA-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
  ],
  TCL_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'username', displayName: 'Username', type: FieldTypesE.TEXT,
    },
    {
      name: 'password', displayName: 'Password', type: FieldTypesE.TEXT,
    },
    {
      name: 'headers.X-TCL-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
  ],
  ACKLIO_LNS_DIRECT_SOURCE: [
  ],
  INNOVID_SOURCE: [
    {
      name: 'sourcePath', displayName: 'Source Path', type: FieldTypesE.TEXT, comment: 'Master address (hexstring) where bcdma-forwarder is installed',
    },
  ],
  CHIRPSTACK_MULTICAST_SOURCE: [
    {
      name: 'downlinkAddress', displayName: 'LPWAN server address', type: FieldTypesE.TEXT,
    },
    {
      name: 'apiKey', displayName: 'API Key', type: FieldTypesE.TEXT,
    },
    {
      name: 'multicastGroupId', displayName: 'Multicast Group ID', type: FieldTypesE.TEXT,
    },
  ],
  CHIRPSTACK_UNICAST_SOURCE: [
    {
      name: 'downlinkAddress', displayName: 'LPWAN server address', type: FieldTypesE.TEXT,
    },
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'apiKey', displayName: 'API Key', type: FieldTypesE.TEXT,
    },
    {
      name: 'headers.X-Chirpstack-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
  ],
  ANTARES_SOURCE: [
    {
      name: 'apiKey', displayName: 'API Key', type: FieldTypesE.TEXT,
    },
    {
      name: 'topic', displayName: 'Topic', type: FieldTypesE.TEXT,
    },
    {
      name: 'keepAlive', displayName: 'Keep Alive', type: FieldTypesE.TEXT,
    },
  ],
  EVERYNET_SOURCE: [
    {
      name: 'apiKey', displayName: 'Access Token', type: FieldTypesE.TEXT,
    },
    {
      name: 'clientID', displayName: 'Client ID', type: FieldTypesE.TEXT,
    },
    {
      name: 'url', displayName: 'Websocket URI', type: FieldTypesE.TEXT,
    },
  ],
  TTS_SOURCE: [
    {
      name: 'downlinkAddress', displayName: 'LPWAN server address', type: FieldTypesE.TEXT,
    },
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'apiKey', displayName: 'Access Token', type: FieldTypesE.TEXT,
    },
    {
      name: 'headers.X-TTS-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
  ],
  IOT_CREATOR_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'username', displayName: 'Username', type: FieldTypesE.TEXT,
    },
    {
      name: 'password', displayName: 'Password', type: FieldTypesE.TEXT,
    },
    {
      name: 'headers.X-IOTCREATOR-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
  ],
  KERLINK_SPN_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
  ],
  KERLINK_WANESY_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'headers.X-KERLINK-WANESY-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
    {
      name: 'downlinkAddress', displayName: 'LPWAN server address', type: FieldTypesE.TEXT,
    },
    {
      name: 'username', displayName: 'Username', type: FieldTypesE.TEXT,
    },
    {
      name: 'password', displayName: 'Password', type: FieldTypesE.TEXT,
    },
  ],
  AWS_IOT_CORE_SOURCE: [
    {
      name: 'url', displayName: 'Callback URI', type: FieldTypesE.TEXT, disabled: true,
    },
    {
      name: 'headers.X-AWS-IOTCORE-Conn-Token', displayName: 'Token', type: FieldTypesE.TEXT_MULTILINES, disabled: true,
    },
    {
      name: 'region', displayName: 'AWS Region', type: FieldTypesE.TEXT,
    },
  ],
  IP_DTLS_SOURCE: [
    {
      name: 'url', displayName: 'UDP address', type: FieldTypesE.TEXT, disabled: true,
    },
  ],
  ACTILITY_THINGPARK_WS_SOURCE: [
    {
      name: 'url', displayName: 'Websocket URL', type: FieldTypesE.TEXT, disabled: true,
    },
  ],
};

export default SourcesForm;
